<template>
    <section class="main" style="position: relative; margin: 0 auto" :style="{'background-color': block.color, 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}">

        <div style="position: absolute; top: 16px; right: 16px;z-index: 2" class="hovered">
            <v-btn icon @click="addPoint">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('move_row_up')">
                <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('move_row_down')">
                <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
            <v-menu top left>
                <template v-slot:activator="{ on }">
                    <v-btn class="link-context-menu" v-on="on" icon  >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>

                </template>
                <v-list>

                    <v-list-item @click="$emit('copy_main_block')">
                        <v-list-item-title>Копировать</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="settings = true">
                        <v-list-item-title>Редактировать</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$emit('block-delete')">
                        <v-list-item-title>Удалить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>

        <v-dialog
                v-model="settings"
                max-width="600px"
                scrollable
        >
            <list-block-settings v-model="block" @close-settings="settings = false"></list-block-settings>
        </v-dialog>

        <v-container>
            <v-row v-for="(item, index) in block.points" :key="item.id" @click.right="openContextMenu(index, $event)" justify="center" style="max-width: 1200px; margin: 0 auto" oncontextmenu="return false;">
                <v-col :cols="cols">
                    <div class="point" style="position: relative">
                        <v-btn class="close-btn" icon style="position: absolute; top: 0; right: 0" @click="delPoint(index)">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <div class="index-container" >
                            <!--<div class="circle-index">{{item.img}}</div>-->
                            <image-uploader
                                    v-model="item.img"
                                    width="70"
                                    height="70"
                            ></image-uploader>
                        </div>
                        <div class="text-container">
<!--                            <div class="title" contenteditable="true" ref="title" @input="updateTitle(index)"></div>-->
                            <html-editor class="title" v-model="item.title" ></html-editor>
                            <html-editor class="description" v-model="item.description" ></html-editor>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>

    </section>
</template>

<script>
    import HtmlEditor from "./HtmlEditor";
    import ListBlockSettings from "./ListBlockSettings";
    import ImageUploader from "./ImageUploader";
    export default {
        props:["block"],
        components: {HtmlEditor, ListBlockSettings,   ImageUploader},
        name: "ListBlock",
        data(){
            return{
                settings: false
            }
        },
        computed: {
            cols() {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return 12
                    case 'sm':
                        return 12
                    case 'md':
                        return 8
                    case 'lg':
                        return 8
                    case 'xl':
                        return 8
                }
                return false
            },
            maxId(){
                if(this.block.points.length == 0){
                    return 0;
                } else {
                    return Math.max(...this.block.points.map(kek => kek.id))
                }
            }
        },
        methods:{
            addPoint(){
                this.block.points.push(
                    {
                        id: this.maxId + 1,
                        title: "Hight Quality",
                        img:'imglink',
                        description: "We are the leading firm by delivering quality and value to our clients. All our professionals have more than 5 years of legal experiences. We like what we do."
                    },
                )
            },
            delPoint(indexx){
                if(this.block.points.length == 1){
                    this.$emit('block-delete')
                }
                this.block.points.splice(indexx, 1);
            }
        }
    }
</script>

<style scoped>
    .point{
        display: flex;
    }

    .point .index-container .circle-index{
        width: 70px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #dc7d43;
        color: #18224b;
        border: 3px solid #18224b;
        line-height: 70px;
        font-size: 30px;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        border-radius: 50%;
        -moz-border-radius: 50%;
        -webkit-border-radius: 50%;
    }

    .point .text-container{
        box-sizing: border-box;
        padding-left: 40px;
        flex: 1;
    }

    .point .text-container .title{
        width: 100%
    }

    .point .text-container .description{
        width: 100%
    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }

    .close-btn{
        opacity: 0;
        transition: 0.3s;
    }

    .point:hover .close-btn{
        opacity: 1;
    }


</style>
